<template>
  <div
    class="nuxt-progress"
    :class="{
      'nuxt-progress-failed': !data.canSucceed,
    }"
    :style="{
      width: data.percent + '%',
      height: props.height + 'px',
      opacity: data.show ? 1 : 0,
      backgroundSize: (100 / data.percent) * 100 + '% auto',
    }"
  />
</template>

<script setup>
const props = defineProps({
  throttle: {
    type: Number,
    default: 200,
  },
  duration: {
    type: Number,
    default: 2000,
  },
  height: {
    type: Number,
    default: 2,
  },
});
// Options & Data
const data = reactive({
  percent: 0,
  show: false,
  canSucceed: true,
});
// Local variables
let timer = null;
let localThrottle = null;
let cut;

// Functions
const clear = () => {
  timer && clearInterval(timer);
  localThrottle && clearTimeout(localThrottle);
  timer = null;
};
const start = () => {
  clear();
  data.percent = 0;
  data.canSucceed = true;

  if (props.throttle) {
    localThrottle = setTimeout(startTimer, props.throttle);
  } else {
    startTimer();
  }
};

const increase = (num) => {
  data.percent = Math.min(100, Math.floor(data.percent + num));
};

const finish = () => {
  data.percent = 100;
  hide();
};
const hide = () => {
  clear();
  setTimeout(() => {
    data.show = false;
    setTimeout(() => {
      data.percent = 0;
    }, 400);
  }, 500);
};
const startTimer = () => {
  data.show = true;
  cut = 10000 / Math.floor(props.duration);
  timer = setInterval(() => {
    increase(cut);
  }, 100);
};

// Hooks
const nuxtApp = useNuxtApp();

nuxtApp.hook('page:start', start);
nuxtApp.hook('page:finish', finish);

onBeforeUnmount(() => clear);
</script>

<style scoped lang="postcss">
.nuxt-progress {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 0;
  opacity: 1;
  transition:
    width 0.1s,
    opacity 0.4s;

  background: linear-gradient(
    120deg,
    hsl(var(--color-brand-dark)) 23.21%,
    hsl(var(--color-brand-light)) 76.8%
  );

  box-shadow: 0 0 2px var(--color-brand-light);

  z-index: 999999;
}
</style>
